import React, { useState, useRef, useEffect } from 'react';
import cx from 'classnames';
import { useSelector, useDispatch } from "react-redux";
import Modal, {
  ModalActions, ModalContent, ModalHeader,
  ModalTitle, ModalSubtitle
} from "../components/Modal";
import { Button } from "../components/Button";
import Select from 'react-select'
import classNames from 'classnames';
import Ai, {
  selectAllVMs, selectAllstandardTemplates, selectAllCustomTemplates,
  selectAllDeployments, selectAllQuotas, selectCommunityVMs
} from '../store/models/Ai';
import {
  getVMOptions, formatPrice, getErrorMsg, generateRandomIdWithPrefix,
  checkIsBasicPlan, getCommunityVMOptions,
  roundUpTo2Decimals,
  convertUnit
} from '../utils';
import { selectCurrentProjectId } from '../store/models/Project';
import { useHistory } from 'react-router-dom';
import { ModalTypes } from '../constants';
import { selectCurrentUser, selectCurrentUserId } from '../store/models/User';
import UIState from '../store/UIState';
import { toast } from "react-toastify";
import Organization, { selectCurrentOrgId } from '../store/models/Organization';
import Loader from "../components/Loader";
import { QuestionMarkIcon } from '../components/Svg';
import Tooltip from '../components/Tooltip';
import CustomSelect from '../components/CustomSelect';
import { Accordion, AccordionHeader } from '../components/Accordion';
import CustomOption from '../components/CustomOption';

const selectStyles = {
  container: styles => ({
    ...styles,
    flex: 1,
    maxWidth: '100%',
    minWidth: 390,
    height: 40,
  }),
  control: (styles, { isFocused }) => ({
    ...styles,
    paddingLeft: 15,
    backgroundColor: '#191D29',
    borderColor: '#3D4463',
    borderRadius: 6,
    boxShadow: isFocused ? '0 0 0 1px #18c99d' : 'none',
    color: '#18c99d',
    ':hover': {
      borderColor: '#18c99d',
      boxShadow: '0 0 0 1px #18c99d',
    },
    '.selected': {
      borderColor: '#18c99d',
      boxShadow: '0 0 0 1px #18c99d',
    }
  }),
  menu: (styles, state) => ({
    ...styles,
    border: '1px solid #3D4463',
    backgroundColor: '#191D29',
  }),
  option: (styles, { data, isDisabled, isFocused, isSelected }) => {
    return {
      ...styles,
      backgroundColor: '#191D29',
      borderColor: '#3D4463',
      color: isDisabled ? '#636B91' : (isFocused ? '#18c99d' : (isSelected ? '#18c99d' : '#636B91')),
      opacity: isDisabled ? 0.5 : 1,
    };
  },
  indicatorsContainer: (styles, { isDisabled }) => ({
    ...styles,
    display: isDisabled ? 'none' : 'flex',
  }),
  dropdownIndicator: (styles, state) => ({
    ...styles,
    color: '#8A8FB5',
  }),
  indicatorSeparator: (styles, state) => ({
    ...styles,
    color: '#636B91',
    backgroundColor: '#636B91',
    display: 'none'
  }),
  input: styles => ({ ...styles }),
  placeholder: styles => ({ ...styles, color: '#636B91' }),
  singleValue: (styles, { data }) => ({ ...styles, color: '#636B91', fontWeight: '500' }),
};

export const CreateDeploymentModal = ({ modalType, onRequestClose, modalId }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useDispatch()
  const history = useHistory();
  const userId = useSelector(state => selectCurrentUserId(state));
  const projectId = useSelector(state => selectCurrentProjectId(state));
  const orgId = useSelector(state => selectCurrentOrgId(state));
  const standardTemplates = useSelector(state => selectAllstandardTemplates(state));
  const deployments = useSelector(state => selectAllDeployments(state, projectId));
  const quotas = useSelector(state => selectAllQuotas(state));
  let isCustom = false;
  let curTemplate = standardTemplates.filter(img => img.id === modalId)[0];
  if (!curTemplate) {
    const customTemplate = useSelector(state => selectAllCustomTemplates(state, projectId))
    curTemplate = customTemplate.filter(img => img.id === modalId)[0];
    isCustom = true;
  }
  // console.log("curTemplate:", curTemplate)
  // console.log("deployments:", deployments)
  const currentUser = useSelector(state => selectCurrentUser(state));
  const defaultImagesOptions = curTemplate && curTemplate?.container_images
    ? curTemplate.container_images.map(img => ({ label: img, value: img })) : []
  const [imagesOptions, setImagesOptions] = useState(defaultImagesOptions);
  const VMs = useSelector(state => selectAllVMs(state));
  let suggestedVM = _.get(curTemplate, 'suggested_vms.0')
  let vmOptions = getVMOptions(VMs, suggestedVM);
  let communityVms = useSelector(state => selectCommunityVMs(state));

  if (!vmOptions || !curTemplate) {
    return <Loader />
  }

  const communityVmOptions = getCommunityVMOptions(communityVms);
  const filteredCVmOptions = communityVmOptions.map(opt => {
    if (!curTemplate) return false;
    const minVRam = _.get(curTemplate, 'min_vram');
    const gpuMem = Number(_.get(opt, 'vm.label_nvidia_com_gpu_memory'));
    return {
      ...opt,
      disabled: minVRam ? gpuMem < Number(minVRam) : false,
      minVRam: convertUnit(minVRam, 'mb', undefined, 0, 1000)
    };
  });

  let defaultVM = vmOptions.filter(o => o.value === suggestedVM)[0] || vmOptions?.[0];
  // const [selectedFramework, setSelectedFramework] = useState('gradio');
  const pUnit = _.get(VMs, `${suggestedVM || vmOptions?.[0]?.value}.price_hour`) / 100;
  let [price, setPrice] = useState({ unit: pUnit, amount: 1 });
  const namePrefix = curTemplate.name.toLowerCase().replace(/[^\w\s]|_/g, '').replace(/\s/g, '').slice(0, 10);
  const defaultName = generateRandomIdWithPrefix(namePrefix, 20);

  const nameRef = useRef();
  const dnameRef = useRef();
  const imageRef = useRef();
  const portRef = useRef();
  const vmRef = useRef();
  const replicaRef = useRef();
  const varsRef = useRef();
  const authUserRef = useRef();
  const authPwdRef = useRef();
  const registryUserRef = useRef();
  const registrPwdRef = useRef();
  const maxHrRef = useRef();

  const [enableAuth, setEnableAuth] = useState(false);
  const [isThetaNode, setIsThetaNode] = useState(true);
  const [cVmLoading, setCVmLoading] = useState(false);
  const [vmOption, setVmOption] = useState(defaultVM);
  const [maxHr, setMaxHr] = useState();
  const [imageLoading, setImageLoading] = useState(false);
  const [imageValue, setImageValue] = useState(curTemplate.name === 'Image to Image'
    ? (imagesOptions[1] || imagesOptions[0]) : imagesOptions[0]);

  useEffect(() => {
    (async () => {
      try {
        setCVmLoading(true);
        await dispatch(Ai.actions.fetchCommunityVMs(projectId));
      } catch (e) {

      } finally {
        setCVmLoading(false);
      }
    })()
  }, [projectId])

  useEffect(() => {
    onVMChange(defaultVM, 'theta');
  }, [])

  const onSubmit = async () => {
    if (error) setError();
    if (_.isNil(userId)) {
      dispatch(UIState.actions.showModal(ModalTypes.SIGNUP))
      return;
    }
    let name = nameRef.current.value;
    if (name.length) {
      if (!/^[A-Za-z0-9]+$/.test(name)) {
        const errorStr = 'Invalid ID. The ID should only contain letters and numbers.'
        setError(errorStr);
        toast.error('Error: ' + errorStr);
        return;
      }
      if (name.length > 20) {
        const errorStr = 'Invalid ID. The length of the ID should be less than or equal to 20.'
        setError(errorStr);
        toast.error('Error: ' + errorStr)
        return;
      }
    }
    let port = portRef.current.value;
    if (!port) {
      const errorStr = 'Container port is required.'
      setError(errorStr);
      toast.error('Error: ' + errorStr)
      return;
    }
    let image = imageRef.current.state.selectValue[0]?.value;
    if (isCustom) {
      image = image[0];
    }
    if (!image) {
      const errorStr = 'Image is required.'
      setError(errorStr);
      toast.error('Error: ' + errorStr)
      return;
    }
    let vm = vmOption.value;
    if (!vm) {
      setError('Machine type is required.');
      return;
    }
    let maxHrRate = ''
    if (maxHr != undefined) {
      maxHrRate = maxHr;
      if (maxHrRate < _.get(price, 'unit')) {
        setError(`Max hourly rate can't be lower than current rate: $${_.get(price, 'unit')}.`);
        return;
      }
    }
    let tags = curTemplate.tags;
    let dname = dnameRef.current.value;
    let authUser = enableAuth ? authUserRef.current.value : "";
    let authPwd = enableAuth ? authPwdRef.current.value : "";
    // console.log('name:', name, ' image:', image)
    // console.log('port:', port, ' vm:', vm)
    // console.log('projectId:', projectId)
    const imageId = curTemplate.id;
    const replica = Number(replicaRef.current.value);
    const registryUsername = registryUserRef.current?.value;
    const registryPwd = registrPwdRef.current?.value;
    const shard = vmOption.shard;
    const newDeployment = {
      name: name,
      project_id: projectId,
      deployment_image_id: imageId,
      container_image: image,
      min_replicas: replica,
      max_replicas: replica,
      vm_id: vm,
      annotations: {
        tags: JSON.stringify(tags),
        nickname: dname
      },
      auth_username: authUser,
      auth_password: authPwd,
      price_hr: Math.ceil(maxHrRate) * 10000 + ''
    }
    if (registryUsername) {
      newDeployment.registry_username = registryUsername;
      newDeployment.registry_password = registryPwd
    }
    if (shard !== undefined) {
      newDeployment.shard = shard;
    }
    if (curTemplate.require_env_vars) {
      let envVars;
      try {
        if (varsRef.current.value.trim() !== '') {
          envVars = JSON.parse(varsRef.current.value);
        } else {
          envVars = null;
        }
      } catch (error) {
        envVars = 'invalid JSON';
      }
      if (envVars == null) {
        setError('Environment varible is requeired.');
        varsRef.current.focus();
        return;
      }
      if (envVars == 'invalid JSON') {
        setError('Environment varible is requeired.');
        varsRef.current.focus();
        return;
      }
      if (!envVars.HUGGING_FACE_HUB_TOKEN) {
        setError('Environment varible must contain HUGGING_FACE_HUB_TOKEN field.');
        varsRef.current.focus();
        return;
      }
      if (envVars.HUGGING_FACE_HUB_TOKEN === 'hf_xxx') {
        setError(<>Please specify your HuggingFace user access token. Click <a target='_blank' href='https://huggingface.co/docs/hub/en/security-tokens'>HERE</a> to learn how to obtain the token.</>);
        varsRef.current.focus();
        return;
      }
      newDeployment.env_vars = envVars;
    }
    // console.log('obj:', newDeployment);
    // return;
    setLoading(true);
    setError(null);
    try {
      const deployment = await dispatch(Ai.actions.createDeployment(newDeployment))
      // console.log('deployment:', deployment);
      await dispatch(Ai.actions.fetchDeployments(projectId));
      onRequestClose();
      history.push(`/dashboard/ai/${projectId}/dedicated-deployments`)
    } catch (e) {
      let quotaId;
      try {
        quotaId = await dispatch(Organization.actions.fetchOrgQuotaId(orgId))
      } catch (e) {
        console.log('error in fetch quotaId:', e.message);
      }
      let error = getErrorMsg(e.message, onRequestClose, currentUser, orgId, vm, checkIsBasicPlan(quotas, quotaId));
      setLoading(false);
      setError(error);
      if (error === e.message) {
        toast.error(e.message)
      }
    }
  }

  const onVMChange = async (v, type = 'theta') => {
    if (!v) return;
    if (type === 'theta') {
      setPrice({ unit: VMs[v.value].price_hour / 100, amount: price.amount });
    } else {
      setPrice({
        unit: roundUpTo2Decimals(communityVms[v.value].label_onthetaedgecloud_com_price_hr / 10000),
        amount: price.amount
      });
    }
    try {
      setImageLoading(true);
      let params = {};
      switch (type) {
        case 'theta':
          params.machine_type = v.value;
          break;
        case 'community':
          const vm = communityVms[v.value];
          params = {
            cuda_major: vm.label_nvidia_com_cuda_runtime_major,
            cuda_minor: vm.label_nvidia_com_cuda_runtime_minor,
            driver_major: vm.label_nvidia_com_cuda_driver_major,
            driver_minor: vm.label_nvidia_com_cuda_driver_minor,
            gpu_count: vm.label_nvidia_com_gpu_count,
            gpu_memory: vm.label_nvidia_com_gpu_memory,
            gpu_product: vm.label_nvidia_com_gpu_product
          }
          break;
        default:
          break;
      }
      let res = await dispatch(Ai.actions.fetchImagesByVMs(curTemplate.id, params));
      let newOptions = res.map(o => ({
        label: o.container_image_uri,
        value: o.container_image_uri,
        is_compatible: o.is_compatible
      }))
      setImagesOptions(newOptions);
      setImageValue(curTemplate.name === 'Image to Image'
        ? (newOptions[1] || newOptions[0]) : newOptions[0])
      setImageLoading(false);
    } catch (e) {
      setImageLoading(false);
      console.log('error:', e.message)
    }
    setVmOption(v);
  }

  const onVMTypeChange = (v) => {
    setIsThetaNode(v => !v)
    if (!isThetaNode) {
      setPrice({ unit: VMs[defaultVM.value].price_hour / 100, amount: price.amount });
      setVmOption(defaultVM);
      setImagesOptions(defaultImagesOptions);
      setImageValue(curTemplate.name === 'Image to Image'
        ? (defaultImagesOptions[1] || defaultImagesOptions[0])
        : defaultImagesOptions[0])
    } else {
      let option = filteredCVmOptions.find(o => !o.disabled) || null;
      setVmOption(option);
      if (option) {
        onVMChange(option, 'community');
        return;
      }
      setPrice({ unit: 0, amount: price.amount })
    }
  }

  useEffect(() => {
    if (price.unit) {
      setMaxHr(price.unit)
    }
  }, [price.unit])

  const handleMaxHrChange = (e) => {
    const value = e.target.value;
    const regex = /^\d*\.?\d{0,2}$/;
    if (regex.test(value)) {
      setMaxHr(value);
    }
  }

  return (<Modal className={cx("CreateDeploymentModal")}
    onRequestClose={onRequestClose}>

    <ModalHeader>
      <ModalTitle align={'row'}>
        Create New Deployment
        <Tooltip tooltip={'Open documentation'}>
          <a href="https://docs.thetatoken.org/docs/serving-generative-ai-models" target='_blank'>
            <QuestionMarkIcon />
          </a>
        </Tooltip>
      </ModalTitle>
      <ModalSubtitle>{curTemplate.name}</ModalSubtitle>
    </ModalHeader>

    <ModalContent>
      <div className='CreateDeploymentModal__row'>
        <div className='CreateDeploymentModal__section-wrap name'>
          <div className='CreateDeploymentModal__select-label'>Deployment ID</div>
          <input className={"CreateDeploymentModal__input"}
            placeholder={'Enter new deployment ID'}
            ref={nameRef}
            defaultValue={defaultName}
            disabled={true}
          />
        </div>
        <div className='CreateNotebookModal__select-wrap name'>
          <div className='CreateNotebookModal__select-label'>Deployment Name&nbsp;<div className='text-optional'>(optional)</div></div>
          <input className={"CreateNotebookModal__input"}
            placeholder={'Enter new deployment name'}
            ref={dnameRef}
          />
        </div>
      </div>
      <div className='CreateDeploymentModal__row'>
        <div className='CreateDeploymentModal__section-wrap image'>
          <div className='CreateDeploymentModal__select-label'>Image</div>
          {imageLoading ? <Loader /> : <Select options={imagesOptions}
            className={"CreateDeploymentModal__selector"}
            // defaultValue={curTemplate.name === 'Image to Image'
            //   ? (isThetaNode
            //     ? (imagesOptions[1] || imagesOptions[0])
            //     : imagesOptions[0])
            //   : imagesOptions[0]}
            value={imageValue}
            onChange={setImageValue}
            styles={selectStyles}
            placeholder={'Select Template Image'}
            isDisabled={imagesOptions.length < 2}
            ref={imageRef}
          />}
        </div>
        <div className='CreateDeploymentModal__section-wrap port'>
          <div className='CreateDeploymentModal__select-label'>Container Port</div>
          <input className={"CreateDeploymentModal__input"}
            placeholder={'Enter new deployment container port'}
            defaultValue={curTemplate ? curTemplate.container_port : 3000}
            ref={portRef}
          />
        </div>
      </div>
      <div className='CreateDeploymentModal__row'>
        <div className='CreateDeploymentModal__select-wrap auth'>
          <div className='CreateDeploymentModal__select-label'>
            Authentication&nbsp;
            <div className='text-optional'>(optional)</div>
          </div>
          <div className='CreateDeploymentModal__select-content'>
            <label className='CreateDeploymentModal__switch'>
              <input className='CreateDeploymentModal__switch-input' type="checkbox" value={enableAuth} onClick={() => setEnableAuth(v => !v)} />
              <span className="CreateDeploymentModal__switch-slider"></span>
            </label>
            <input className={"CreateDeploymentModal__input auth"}
              placeholder={enableAuth ? 'Enter authentication username' : 'Authentication disabled'}
              disabled={!enableAuth}
              ref={authUserRef}
              type='text'
            />
            <input className={"CreateDeploymentModal__input auth"}
              placeholder={enableAuth ? 'Enter authentication password' : 'Authentication disabled'}
              disabled={!enableAuth}
              ref={authPwdRef}
              type='password'
            />
          </div>
        </div>
      </div>
      <div className='CreateDeploymentModal__row'>
        <div className='CreateDeploymentModal__section-wrap switch'>
          <div className='CreateDeploymentModal__select-label'>
            {'Community nodes'}
          </div>
          <div className='CreateDeploymentModal__select-content switch'>
            <label className='CreateDeploymentModal__switch'>
              <input className='CreateDeploymentModal__switch-input'
                type="checkbox"
                value={isThetaNode}
                onClick={onVMTypeChange}
              />
              <span className="CreateDeploymentModal__switch-slider"></span>
            </label>
          </div>
        </div>
        <div className='CreateDeploymentModal__section-wrap vms'>
          <div className='CreateDeploymentModal__select-label'>Machine type</div>
          {isThetaNode ? <CustomSelect options={vmOptions}
            className={"CreateDeploymentModal__selector"}
            value={vmOption}
            styles={selectStyles}
            placeholder={'Select Machine type'}
            isDisabled={vmOptions.length < 2}
            selectRef={vmRef}
            onChange={(v) => onVMChange(v, 'theta')}
            isOptionDisabled={(option) => {
              if (!suggestedVM) return false;
              return option.price < Number(VMs[suggestedVM].price_hour)
            }} /> : (cVmLoading ? <Loader /> : <CustomSelect options={filteredCVmOptions}
              className={"CreateDeploymentModal__selector"}
              value={vmOption}
              styles={selectStyles}
              placeholder={'Select Machine type'}
              // isDisabled={communityVmOptions.length < 2}
              selectRef={vmRef}
              onChange={(v) => onVMChange(v, 'community')}
              customComponents={{ Option: CustomOption }}
              noOptionsMessage={() => "No community node available"}
              isOptionDisabled={(option) => option.disabled}
            />)}
        </div>
      </div>
      {curTemplate.require_env_vars && <div className='CreateDeploymentModal__row'>
        <div className='CreateDeploymentModal__section-wrap args'>
          <div className='CreateDeploymentModal__select-label'>Container Environment Variables</div>
          <input className={"CreateDeploymentModal__input"}
            placeholder={'Enter model environment variables. Ex: {"key1": "value1", "key2": "value2", ...}'}
            defaultValue={curTemplate.env_vars ? JSON.stringify(curTemplate.env_vars) : ''}
            ref={varsRef}
          />
        </div>
      </div>}
      <Accordion
        header={<AccordionHeader
          title="Advanced Options"
        />}
        body={<>
          {isCustom && <div className='CreateDeploymentModal__row'>
            <div className='CreateDeploymentModal__section-wrap name'>
              <div className='CreateDeploymentModal__select-label'>
                Private image registry username&nbsp;
                <div className='text-optional'>(optional)</div>
              </div>
              <input className={"CreateDeploymentModal__input"}
                placeholder={'Enter image registry username'}
                defaultValue={curTemplate ? curTemplate.registryUsername : ''}
                ref={registryUserRef}
              />
            </div>
            <div className='CreateDeploymentModal__section-wrap name'>
              <div className='CreateDeploymentModal__select-label'>
                Private image registry password&nbsp;
                <div className='text-optional'>(optional)</div>
              </div>
              <input className={"CreateDeploymentModal__input"}
                placeholder={'Enter registry password or access token'}
                defaultValue={curTemplate ? curTemplate.registryPassword : ''}
                ref={registrPwdRef}
              />
            </div>
          </div>}
          <div className='CreateDeploymentModal__row'>
            <div className='CreateDeploymentModal__section-wrap name'>
              <div className='CreateDeploymentModal__select-label'>Replicas</div>
              <div className='CreateDeploymentModal__row-wrap'>
                <NumberInputSection className='CreateDeploymentModal__number-input-section half'
                  defaultValue={1} vRef={replicaRef} setPrice={setPrice} />
              </div>
            </div>
            {!isThetaNode && <div className='CreateDeploymentModal__section-wrap name'>
              <div className='CreateDeploymentModal__select-label'>Max Hourly Rate ($)</div>
              <div className='CreateDeploymentModal__row-wrap'>
                <input className={"ManageGpuNodeModal__input"}
                  placeholder={'Set Max Hourly Rate'}
                  type="number"
                  value={maxHr}
                  onChange={handleMaxHrChange}
                  step={0.01}
                />
              </div>
            </div>}
          </div>
        </>} />
      {!isNaN(price.unit) && <div className='CreateDeploymentModal__price-info'>
        <div className='CreateDeploymentModal__price-info--note'>
          Cost Estimation
        </div>
        <div className='CreateDeploymentModal__price-info--price'>
          ~ ${formatPrice(price.unit * price.amount)} per hour.
        </div>
      </div>}
      {error && <div className={cx("CreateDeploymentModal__error")}>{error}</div>}
    </ModalContent>

    <ModalActions>
      <Button color={"green"} onClick={onSubmit} title={"Create New Deployment"} loading={loading} />
      <Button color={"transparent"} onClick={onRequestClose} title={"Cancel"} />
    </ModalActions>

  </Modal>
  );
}


function NumberInputSection(props) {
  const { className, label, defaultValue = 0, vRef, setPrice } = props;
  const [value, setValue] = useState(defaultValue);
  const [isInputFocused, setInputFocused] = useState(false);
  const [isButtonClicked, setButtonClicked] = useState(false);
  const parentRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (parentRef.current && !parentRef.current.contains(event.target)) {
        setInputFocused(false);
        setButtonClicked(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);


  const decreaseValue = () => {
    if (value > 1) {
      setValue(value - 1);
      setPrice(p => ({ unit: p.unit, amount: value - 1 }))
    }
    setButtonClicked(true);
  };

  const increaseValue = () => {
    setValue(value + 1);
    setPrice(p => ({ unit: p.unit, amount: value + 1 }))
    setButtonClicked(true);
  };

  const handleOnChange = (e) => {
    let v = Math.max(Number(e.target.value), 1);
    setValue(v);
    setPrice(p => ({ unit: p.unit, amount: v }))
  }

  const handleFocus = () => {
    setInputFocused(true);
  };

  const handleBlur = () => {
    setInputFocused(false);
  };


  return (
    <div className={classNames("number-input", className, { 'focus': isInputFocused || isButtonClicked })} ref={parentRef}>
      {label && <label htmlFor="number-input" className='number-input__label'>{label}</label>}
      <div className={classNames("number-input__group", { 'no-label': !label })}>
        <div className="number-input__button" onMouseDown={decreaseValue}>-</div>
        <input
          type="number"
          id="number-input"
          className='number-input__input'
          inputMode="numeric"
          value={value}
          onChange={handleOnChange}
          ref={vRef}
          min={1}
          onFocus={handleFocus}
          onBlur={handleBlur}
        />
        <div className="number-input__button" onMouseDown={increaseValue}>+</div>
      </div>
    </div>
  );
}

export default NumberInputSection;